import React from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { manuallyIssueTicket } from "../../../services/booking-service";

const getTravelerName = (t) => {
  if (typeof t?.name === "string") return t.name;
  const firstName = t?.firstName || t?.name?.firstName || "";
  const lastName = t?.lastName || t?.name?.lastName || "";
  return `${firstName} ${lastName}`.trim();
};

const getTicketTravelers = (booking) =>
  (booking?.travelerSummary && booking.travelerSummary.length > 0
    ? booking.travelerSummary
    : booking?.booking_reference?.data?.travelers) || [];

const IssueTicketModal = ({ open, booking, onClose, onSuccess }) => {
  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const onFinish = (values) => {
    const { PNR } = values;
    const travelers = getTicketTravelers(booking);
    const tickets = travelers.map((t, index) => ({
      traveler: getTravelerName(t),
      ticket_number: values[`ticket_number_${index}`],
    }));

    manuallyIssueTicket({ tramangoId: booking?.tramangoId, PNR, tickets })
      .then((data) => {
        message.success(data?.message ?? "Ticket issued");
        handleClose();
        onSuccess?.();
      })
      .catch((error) => {
        message.error(
          error?.response?.data?.message ?? "Failed to issue ticket",
        );
      });
  };

  const travelers = getTicketTravelers(booking);

  return (
    <Modal title="Issue Ticket" open={open} onCancel={handleClose} footer={null}>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          label="PNR"
          name="PNR"
          rules={[{ required: true, message: "Please enter the PNR" }]}
        >
          <Input style={{ width: "100%" }} />
        </Form.Item>

        {travelers.map((t, index) => (
          <Form.Item
            label={`Enter ticket number for ${getTravelerName(t)}`}
            name={`ticket_number_${index}`}
            rules={[
              { required: true, message: "Please enter the Ticket Number" },
            ]}
            key={index}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
        ))}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Manually Issue Ticket
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default IssueTicketModal;
